import { IComboBoxOption } from "@fluentui/react";
import { List } from "linq.ts";

export enum DataType {
    undefined = 0,
    string = 1,
    byte = 2,
    short = 3,
    int = 4,
    long = 5,
    decimal = 6,
    float = 7,
    double = 8,
    boolean = 9,
    date = 10,
    time = 11,
    datetime = 12,
    uniqueIdentifier = 13,
    oneToMany = 14,
    children = 15,
    manyToMany = 16,
    parent = 17,
    range = 19
}

export const DataTypeDataSource: IComboBoxOption[] = new List<IComboBoxOption>([
    { key: DataType.string, text: `Cadena de texto (Longitud variable) [${DataType[ DataType.string ]} ${DataType.string}]` },
    { key: DataType.byte, text: `Byte (0 a 255) [${DataType[ DataType.byte ]} ${DataType.byte}]` },
    { key: DataType.short, text: `Entero corto (short) (-32,768 a 32,767) [${DataType[ DataType.short ]} ${DataType.short}]` },
    { key: DataType.int, text: `Entero (int) (-2^31 a 2^31-1) [${DataType[ DataType.int ]} ${DataType.int}]` },
    { key: DataType.long, text: `Entero largo (long) (-2^63 a 2^63-1) [${DataType[ DataType.long ]} ${DataType.long}]` },
    { key: DataType.decimal, text: `Decimal (±1.0 x 10^-28 a ±7.9 x 10^28) [${DataType[ DataType.decimal ]} ${DataType.decimal}]` },
    { key: DataType.float, text: `Flotante (±1.5 x 10^-45 a ±3.4 x 10^38) [${DataType[ DataType.float ]} ${DataType.float}]` },
    { key: DataType.double, text: `Doble precisión (±5.0 x 10^-324 a ±1.7 x 10^308) [${DataType[ DataType.double ]} ${DataType.double}]` },
    { key: DataType.boolean, text: `Booleano (Verdadero o Falso) [${DataType[ DataType.boolean ]} ${DataType.boolean}]` },
    { key: DataType.date, text: `Fecha [${DataType[ DataType.date ]} ${DataType.date}]` },
    { key: DataType.time, text: `Hora [${DataType[ DataType.time ]} ${DataType.time}]` },
    { key: DataType.datetime, text: `Fecha y hora [${DataType[ DataType.datetime ]} ${DataType.datetime}]` },
    { key: DataType.uniqueIdentifier, text: `Identificador único (Guid) [${DataType[ DataType.uniqueIdentifier ]} ${DataType.uniqueIdentifier}]` },
    { key: DataType.oneToMany, text: `Referencia a otra entidad (No afecta entidad relacionada) [${DataType[ DataType.oneToMany ]} ${DataType.oneToMany}]` },
    { key: DataType.children, text: `Colección de entidades hijas [${DataType[ DataType.children ]} ${DataType.children}]` },
    { key: DataType.manyToMany, text: `Referencia a una o más entidades (Muchos a muchos) [${DataType[ DataType.manyToMany ]} ${DataType.manyToMany}]` },
]).OrderBy(x => x.text).ToArray();

export const isNumber = (value: DataType): boolean => {
    return value === DataType.byte
        || value === DataType.short
        || value === DataType.int
        || value === DataType.long
        || value === DataType.decimal;
}

export const isString = (value: DataType): boolean => {
    return value === DataType.string
        || value === DataType.uniqueIdentifier;
}

export const isDate = (value: DataType): boolean => {
    return value === DataType.date
        || value === DataType.datetime;
}
